import * as types from "./actionTypes";

export const getList = () => {
  return {
    type: types.GET_TEAMS_LIST_REQUEST
  };
};

export const getListSuccess = data => {
  return {
    type: types.GET_TEAMS_LIST_SUCCESS,
    data: data
  };
};

export const getListFailure = error => {
  return {
    type: types.GET_TEAMS_LIST_FAILURE,
    error
  };
};

export const show = id => {
  return {
    type: types.SHOW_TEAM_REQUEST,
    id
  };
};

export const showSuccess = data => {
  return {
    type: types.SHOW_TEAM_SUCCESS,
    payLoad: data
  };
};

export const showFailure = error => {
  return {
    type: types.SHOW_TEAM_FAILURE,
    error: error
  };
};

export const remove = id => {
  return {
    type: types.REMOVE_TEAM_REQUEST,
    id
  };
};

export const removeSuccess = (id) => {
  return {
    type: types.REMOVE_TEAM_SUCCESS,
    id
  };
};

export const removeFailure = () => {
  return {
    type: types.REMOVE_TEAM_FAILURE
  };
};

export const store = (projectId, data) => {
  return {
    type: types.STORE_TEAM_REQUEST,
    projectId,
    data
  };
};

export const storeSuccess = (projectId, data) => {
  return {
    type: types.STORE_TEAM_SUCCESS,
    projectId,
    payLoad: data
  };
};

export const storeFailure = () => {
  return {
    type: types.STORE_TEAM_FAILURE
  };
};

export const update = (id, data) => {
  return {
    type: types.UPDATE_TEAM_REQUEST,
    id,
    data
  };
};

export const updateSuccess = data => {
  return {
    type: types.UPDATE_TEAM_SUCCESS,
    payLoad: data
  };
};

export const updateFailure = () => {
  return {
    type: types.UPDATE_TEAM_FAILURE
  };
};

export const setTeamModalData = data => {
  return {
    type: types.SET_TEAM_MODAL_DATA,
    data: data
  };
};
export const closeTeamModal = data => {
  return {
    type: types.CLOSE_TEAM_MODAL,
    data: data
  };
};

export const clearLastAdded = () => {
  return {
    type: types.CLEAR_LAST_ADDED_TEAM
  };
};

export const getLevels = id => {
  return {
    type: types.GET_TEAM_LEVELS_REQUEST,
    id
  };
};
export const getLevelsSuccess = data => {
  return {
    type: types.GET_TEAM_LEVELS_SUCCESS,
    data: data
  };
};
export const getLevelsFailure = error => {
  return {
    type: types.GET_TEAM_LEVELS_FAILURE,
    error: error
  };
};

export const reorderLevels = (id, data) => {
  return {
    type: types.REORDER_TEAM_LEVELS_REQUEST,
    id,
    data
  };
};
export const reorderLevelsSuccess = () => {
  return {
    type: types.REORDER_TEAM_LEVELS_SUCCESS
  };
};
export const reorderLevelsFailure = () => {
  return {
    type: types.REORDER_TEAM_LEVELS_FAILURE
  };
};

export const showLevel = (id, levelId) => {
  return {
    type: types.SHOW_TEAM_LEVEL_REQUEST,
    id,
    levelId
  };
};

export const showLevelSuccess = data => {
  return {
    type: types.SHOW_TEAM_LEVEL_SUCCESS,
    data: data
  };
};

export const showLevelFailure = error => {
  return {
    type: types.SHOW_TEAM_LEVEL_FAILURE,
    error: error
  };
};

export const removeLevel = (id, levelId) => {
  return {
    type: types.REMOVE_TEAM_LEVEL_REQUEST,
    id,
    levelId
  };
};
export const removeLevelSuccess = id => {
  return {
    type: types.REMOVE_TEAM_LEVEL_SUCCESS,
    payLoad: id
  };
};
export const removeLevelFailure = () => {
  return {
    type: types.REMOVE_TEAM_LEVEL_FAILURE
  };
};

export const storeLevel = (id, data) => {
  return {
    type: types.STORE_TEAM_LEVEL_REQUEST,
    id,
    data
  };
};
export const storeLevelSuccess = data => {
  return {
    type: types.STORE_TEAM_LEVEL_SUCCESS,
    payLoad: data
  };
};
export const storeLevelFailure = () => {
  return {
    type: types.STORE_TEAM_LEVEL_FAILURE
  };
};

export const updateLevel = (id, levelId, data) => {
  return {
    type: types.UPDATE_TEAM_LEVEL_REQUEST,
    id,
    levelId,
    data
  };
};
export const updateLevelSuccess = data => {
  return {
    type: types.UPDATE_TEAM_LEVEL_SUCCESS,
    payLoad: data
  };
};
export const updateLevelFailure = () => {
  return {
    type: types.UPDATE_TEAM_LEVEL_FAILURE
  };
};

export const setTeamLevelModalData = data => {
  return {
    type: types.SET_TEAM_LEVEL_MODAL_DATA,
    data: data
  };
};
export const closeTeamLevelModal = data => {
  return {
    type: types.CLOSE_TEAM_LEVEL_MODAL,
    data: data
  };
};

export const removeLevelApprover = (id, levelId, userId) => {
  return {
    type: types.REMOVE_TEAM_LEVEL_APPROVER_REQUEST,
    id,
    levelId,
    userId
  };
};
export const removeLevelApproverSuccess = () => {
  return {
    type: types.REMOVE_TEAM_LEVEL_APPROVER_SUCCESS
  };
};
export const removeLevelApproverFailure = () => {
  return {
    type: types.REMOVE_TEAM_LEVEL_APPROVER_FAILURE
  };
};

export const getLevelApprovers = (id, levelId) => {
  return {
    type: types.GET_TEAM_LEVEL_APPROVERS_REQUEST,
    id,
    levelId
  };
};
export const getLevelApproversSuccess = data => {
  return {
    type: types.GET_TEAM_LEVEL_APPROVERS_SUCCESS,
    data: data
  };
};
export const getLevelApproversFailure = error => {
  return {
    type: types.GET_TEAM_LEVEL_APPROVERS_FAILURE,
    error: error
  };
};

export const storeLevelApprover = (id, levelId, data) => {
  return {
    type: types.STORE_TEAM_LEVEL_APPROVER_REQUEST,
    id,
    levelId,
    data
  };
};
export const storeLevelApproverSuccess = () => {
  return {
    type: types.STORE_TEAM_LEVEL_APPROVER_SUCCESS
  };
};
export const storeLevelApproverFailure = () => {
  return {
    type: types.STORE_TEAM_LEVEL_APPROVER_FAILURE
  };
};

export const setConfirmData = data => {
  return {
    type: types.SET_TEAM_SHOW_CONFIRM_DATA,
    data: data
  };
};


export const updateWidgets = (id, data) => {
  return {
    type: types.UPDATE_TEAM_WIDGETS_REQUEST,
    id,
    data
  };
};

export const updateWidgetsSuccess = data => {
  return {
    type: types.UPDATE_TEAM_WIDGETS_SUCCESS,
    payLoad: data
  };
};

export const updateWidgetsFailure = () => {
  return {
    type: types.UPDATE_TEAM_WIDGETS_FAILURE,
  };
};